import {memo} from 'react';
import {SubwayData} from '@/map/@types';
import {
  AROUND_DATA_OPTIONS,
  MIN_SUBWAY_PASSENGERS_COUNT,
} from '@/map/constants';
import {AreaAnalyticsFilter} from '@/map/enums';
import {withComma} from '@/utils';
import {NearbyInfoMarker} from './Marker';

interface IProps extends naver.maps.MarkerOptions {
  item: SubwayData;
}

export const SubwayMarker = memo(
  ({map, position, item}: IProps) => {
    if (!item || !item.subways?.length) {
      return null;
    }

    const subways = item.subways.filter(
      (i) => !i.getOnOffAvg || i.getOnOffAvg > MIN_SUBWAY_PASSENGERS_COUNT
    );

    if (!subways.length) {
      return null;
    }

    const name = subways.map(
      (i) =>
        `${i.line} ${i.name}${
          subways.length > 1 ? ` ${withComma(i.getOnOffAvg)}명` : ''
        }`
    );

    const totalCount = subways
      .map((x) => x.getOnOffAvg)
      .reduce((a, b) => a + b, 0);

    if (!totalCount || totalCount > MIN_SUBWAY_PASSENGERS_COUNT) {
      return (
        <NearbyInfoMarker
          typeInfo={AROUND_DATA_OPTIONS[AreaAnalyticsFilter.SUBWAY]}
          config={{
            map,
            position,
          }}
          item={{
            name,
            count: !!totalCount ? totalCount : undefined,
          }}
        />
      );
    }

    return null;
  },
  (prevProps: IProps, nextProps: IProps) => {
    return prevProps.position.toString() === nextProps.position.toString();
  }
);
